import gql from "graphql-tag"

const DOWNLOAD_GALLERY_IMAGE_ITEM = gql`
query DownloadGalleryImage($galleryImageId: ID!,$caseFolderId:ID!)
{
      downloadGalleryImage(galleryImageItemId:$galleryImageId,caseFolderId:$caseFolderId) {
      downloadUrls
    }
}
`;

export default DOWNLOAD_GALLERY_IMAGE_ITEM